import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJTV from './DJTV';
// import DJTVPrint from '../DJTVPrint/DJTVPrint';

//Estilos

function DJCPContainer() {
    const { token, masters, grapesVariety, settings, formatNumber } =
        useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [print, setPrint] = useState(false);
    const [WatchDJTVLogs, setWatchDJTVLogs] = useState(false);
    const [DJTVData, setDJTVData] = useState({});

    const Params = useParams();

    useEffect(() => {
        // const getMyDJTV = async () => {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJTV segun el id que esta en los params
        //         const MyDJTVs = await DJTVService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         //Si la respuesta es correcta seteamos el estado de myDJCP con los datos de la respuesta
        //         if (MyDJTVs) {
        //             const getNombreUsuario = await UserService.getNombreUsuario(
        //                 { token, usuarioId: MyDJTVs.data.cabecera.usuario }
        //             );
        //             if (getNombreUsuario) {
        //                 setDJTVData({
        //                     ...MyDJTVs.data,
        //                     ...getNombreUsuario.data,
        //                 });
        //             }
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // };
        // getMyDJTV();
    }, [Params.id]);

    return loader ? (
        <Spinner />
    ) : (
        <>
            <DJTV
                functions={{
                    formatNumber,
                    setPrint,
                    setWatchDJTVLogs,
                }}
                states={{ WatchDJTVLogs, DJTVData, masters }}
            />
            {/* <DJTVPrint
                        functions={{
                            formatNumber,
                            setPrint,
                        }}
                        states={{
                            DJTVData,
                            masters,
                            grapesVariety,
                            settings,
                        }}
                    /> */}
        </>
    );
}

export default DJCPContainer;
